import React, { useState } from "react";
import "./FlowTabs.scss";

function FlowTabs({ children, activeTab = 0 }) {
  const [activeIndex, setActiveIndex] = useState(activeTab);
  const tabs = React.Children.toArray(children);

  return (
    <div className="flow-tabs">
      <div className="flow-tabs-header">
        {tabs.map((tab, idx) => (
          <React.Fragment key={idx}>
            <div
              className={`flow-tab-title${activeIndex === idx ? " active" : ""}`}
              onClick={() => setActiveIndex(idx)}
            >
              {tab.props.title}
            </div>
          </React.Fragment>
        ))}
      </div>
      <div className="flow-tabs-content">{tabs[activeIndex]}</div>
    </div>
  );
}

export default FlowTabs;
